import { render } from "./RecentlyVisited.vue?vue&type=template&id=407693b6&scoped=true"
import script from "./RecentlyVisited.vue?vue&type=script&lang=js"
export * from "./RecentlyVisited.vue?vue&type=script&lang=js"

import "./RecentlyVisited.vue?vue&type=style&index=0&id=407693b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407693b6"]])

export default __exports__